module.exports = __webpack_public_path__ + "static/media/in-app-purchase.2dd533b1.jpg";